export const  errorRedirect = (errorKey) => {
	window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=" + errorKey;
}

export const  pageRedirect = (path) => {
	window.location.href = process.env.REACT_APP_HOST_API_URL +  path;
}

export const  loginRedirect = () => {
	window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/auth/login"
}

export default function validateResponse(response) {
    if (!response.ok) {
        if (response.status === 401) {
        	loginRedirect();
            return null;
        } else {
            throw new Error("Unknown error occurred : " + response.statusText);
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/Util.js